"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProdConfigHelper_1 = require("./shared/ProdConfigHelper");
var QA_CONFIG = (0, ProdConfigHelper_1.generateProdConfigBy)({
    ENV_NAME: "quality",
    HOST_ENDPOINT: "https://qa.unipol.it",
    CMS_PROXY_NO_APIC_ENDPOINT: "https://tpd-cms-proxy-qa.servizi.gr-u.it/cms-proxy",
    NETWORK_CONFIG: {
        clientId: "713e8770-0bde-47cb-ac0b-f0faf211d0af",
        clientSecret: "vB3hL4rC5uM6xQ8wX0uH4vL8fR3iC0xL2tC8iN0bK6cW2pB7iO",
        apiKey: "AIzaSyBdutiwcN-MfwP4a31SKdRGgv5qtktHSvA",
    },
});
exports.default = QA_CONFIG;
